/**
 * FAQ page: category filter and live search over the questions and answers
 * (each .faq-item carries data-question / data-answer in lower case).
 */
export function initFaq() {
    const container = document.getElementById('faqContainer');
    if (!container) {
        return;
    }
    const search = document.getElementById('faqSearch');
    const noResults = document.getElementById('noResults');
    const buttons = [...document.querySelectorAll('.category-btn[data-category]')];
    const items = [...container.querySelectorAll('.faq-item')];
    const categories = [...container.querySelectorAll('.faq-category')];
    let category = 'all';

    const apply = () => {
        const q = (search?.value || '').trim().toLowerCase();
        let shown = 0;
        items.forEach((item) => {
            const inCategory = category === 'all' || item.dataset.category === category;
            const matches = !q || item.dataset.question.includes(q) || item.dataset.answer.includes(q);
            item.hidden = !(inCategory && matches);
            if (!item.hidden) {
                shown += 1;
                if (q) { item.open = true; }
            }
        });
        categories.forEach((cat) => { cat.hidden = !cat.querySelector('.faq-item:not([hidden])'); });
        if (noResults) { noResults.hidden = shown > 0; }
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
        category = button.dataset.category;
        buttons.forEach((b) => {
            b.classList.toggle('is-active', b === button);
            b.setAttribute('aria-pressed', String(b === button));
        });
        apply();
    }));
    search?.addEventListener('input', apply);
}
